// actions/faqActions.ts

import {
  FETCH_FAQ_CATEGORIES_REQUEST,
  FETCH_FAQ_CATEGORIES_SUCCESS,
  FETCH_FAQ_CATEGORIES_FAILURE,
  FETCH_FAQ_CATEGORIES_LOADING,
  SAVE_FAQ_FORM_REQUEST,
  SAVE_FAQ_FORM_SUCCESS,
  SAVE_FAQ_FORM_FAILURE,
  SAVE_FAQ_FORM_LOADING,
  FETCH_FAQ_LIST_DATA_REQUEST,
  FETCH_FAQ_LIST_DATA_SUCCESS,
  FETCH_FAQ_LIST_DATA_FAILURE,
  FETCH_FAQ_LIST_DATA_LOADING,
  DELETE_FAQ_REQUEST,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAILURE,
  DELETE_FAQ_LOADING
} from '../actionTypes';

export const updateFaqFormField = (field: string, value: any) => {
  return {
    type: 'UPDATE_FAQ_FORM_FIELD',
    payload: {
      field,
      value,
    },
  };
};

export const updateFaqFormErrors = (errors: { [key: string]: string }) => {
  return {
    type: 'UPDATE_FAQ_FORM_ERRORS',
    payload: errors,
  };
};

//  Faq Categories Actions

export const fetchFaqCategories = () => {
  return {
    type: FETCH_FAQ_CATEGORIES_REQUEST,
  };
};
export const fetchFaqCategoriesSuccess = (payload: any) => {
  return {
    type: FETCH_FAQ_CATEGORIES_SUCCESS,
    payload,
  };
};
export const fetchFaqCategoriesFailure = (payload: any) => {
  return {
    type: FETCH_FAQ_CATEGORIES_FAILURE,
    payload,
  };
};
export const fetchFaqCategoriesLoading = (payload: any) => {
  return {
    type: FETCH_FAQ_CATEGORIES_LOADING,
    payload,
  };
};

// Save Faq Form Actions

export const saveFaqFormData = (payload: any) => {
  return {
    type: SAVE_FAQ_FORM_REQUEST,
    payload,
  };
};
export const saveFaqFormDataSuccess = (payload: any) => {
  return {
    type: SAVE_FAQ_FORM_SUCCESS,
    payload,
  };
};
export const saveFaqFormDataFailure = (payload: any) => {
  return {
    type: SAVE_FAQ_FORM_FAILURE,
    payload,
  };
};
export const saveFaqFormDataLoading = (payload: any) => {
  return {
    type: SAVE_FAQ_FORM_LOADING,
    payload,
  };
};

// FAQ List

export const fetchFaqListData = () => {
  return {
    type: FETCH_FAQ_LIST_DATA_REQUEST,
  };
};

export const fetchFaqListDataSuccess = (payload: any) => {
  return {
    type: FETCH_FAQ_LIST_DATA_SUCCESS,
    payload,
  };
};

export const fetchFaqListDataFailure = (payload: any) => {
  return {
    type: FETCH_FAQ_LIST_DATA_FAILURE,
    payload,
  };
};

export const fetchFaqListDataLoading = (payload: any) => {
  return {
    type: FETCH_FAQ_LIST_DATA_LOADING,
    payload,
  };
};


// Set FAQ Edit Data

export const setFaqEditData = (payload: any) => {
  return {
    type: 'SET_FAQ_EDIT_DATA_REQUEST',
    payload,
  };
}

export const setFaqEditDataSuccess = (payload: any) => {
  return {
    type: 'SET_FAQ_EDIT_DATA_SUCCESS',
    payload,
  };
}

export const setFaqEditDataFailure = (payload: any) => {
  return {
    type: 'SET_FAQ_EDIT_DATA_FAILURE',
    payload,
  };
}

export const setFaqEditDataLoading = () => {
  return {
    type: 'SET_FAQ_EDIT_DATA_LOADING'
  };
};

// Set FAQ Form State (e.g., 'create' or 'edit')
export const setFaqFormState = (payload: string) => {
  return {
    type: 'SET_FAQ_FORM_STATE',
    payload,
  };
};


// Delete FAQ Actions

export const deleteFaq = (payload: string) => {
  return {
    type: DELETE_FAQ_REQUEST,
    payload,
  };
};

export const deleteFaqSuccess = () => {
  return {
    type: DELETE_FAQ_SUCCESS,
  };
};

export const deleteFaqFailure = () => {
  return {
    type: DELETE_FAQ_FAILURE,
  };
};

export const deleteFaqLoading = () => {
  return {
    type: DELETE_FAQ_LOADING,
  };
};

export const resetFaqForm = () => {
  return {
    type: 'RESET_FAQ_FORM',
  };
};

export const setIsFaqFormSaved = (payload: boolean) => {
  return {
    type: 'SET_IS_FAQ_FORM_SAVED',
    payload,
  };
};

export const setFaqFormSavedError = (payload: string) => {
  return {
    type: 'SET_FAQ_FORM_SAVED_ERROR',
    payload,
  };
};

export const setIsFaqDeleted = (payload: boolean) => {
  return {
    type: 'SET_IS_FAQ_DELETED',
    payload,
  };
};

// Export FAQ Data Action
export const exportFaqData = (payload: any) => {
  return {
    type: 'EXPORT_FAQ_DATA_REQUEST',
    payload,
  };
};
export const exportFaqDataSuccess = () => {
  return {
    type: 'EXPORT_FAQ_DATA_SUCCESS',
  };
};
export const exportFaqDataFailure = () => {
  return {
    type: 'EXPORT_FAQ_DATA_FAILURE'
  };
};

export const exportFaqDataLoading = () => {
  return {
    type: 'EXPORT_FAQ_DATA_LOADING',
  };
};



